export { default } from './InvestmentChatbot'
